import React from "react";

export default function VideoForm() {

    return (
        <>
            <div className="form-card">
                <div className="form-header">
                    <h4>Quick Enquiry</h4>
                    <p>Get Free Consultation Within Minutes</p>
                </div>
                <iframe
                    src="https://crm.yourdoorstep.co/form/index/UTY=/crm.yourdoorstep.co/103.152.79.163"
                    width="100%"
                    height="520"
                    style={{ border: "none" }}
                    title="YourDoorstep Form"
                ></iframe>
            </div>
        </>
    );
}
